// ============================================
// 外部ファイル
// ============================================
import logoRotateAnimation from '../animation/logoRotateAnimation';
import './top/carousel/index.js';
import './top/load/index.js';

(() => {

	// ============================================
	// ABOUT・背景動画遅延読み込み
	// ============================================
	const loadingVideo = () => {
		const video = document.querySelector('[data-video-target]');

		if (!video) return; // 要素がなければスルー

		const source = document.createElement('source');
		source.src = video.dataset.src;
		source.type = 'video/mp4';

		video.appendChild(source);
		video.load();
		video.play();
	};

	// ============================================
	// ページ上部に戻るボタンの表示切り替え
	// ============================================

	const pageTop = () => {

		const pageTopElement = document.querySelector('[data-page-top-target]');
		const pageTopTrigger = document.querySelector('[data-page-top-trigger]');
		const addClassName = 'is-active';

		// 要素がなければスルー
		if (!pageTopElement || !pageTopTrigger) return;

		// ページトップボタンの表示状態をチェック
		const checkPageTop = () => {

			// ページトップボタンの現在の画面上の位置を取得
			const pageTopRect = pageTopElement.getBoundingClientRect();

			// MVの現在の画面上の位置を取得
			const triggerRect = pageTopTrigger.getBoundingClientRect();

			// MVの下端がページトップボタンの上端を通過したか判定
			if (triggerRect.bottom < pageTopRect.top) {

				// クラス付与
				pageTopElement.classList.add(addClassName);

			} else {

				// クラスを削除
				pageTopElement.classList.remove(addClassName);
			}
		};

		// スクロール時に位置をチェック
		window.addEventListener('scroll', checkPageTop);

		// リサイズイベントが連続して発生した場合の処理軽減
		let resizeTimer;

		window.addEventListener('resize', () => {

			// 前回のタイマーが残っていたらキャンセル
			clearTimeout(resizeTimer);

			// リサイズが終わってから200ms待って処理を実行
			resizeTimer = setTimeout(() => {
				checkPageTop();
			}, 200);
		});

		// 初期化
		checkPageTop();
	};

	// ============================================
	// 実行
	// ============================================
	window.addEventListener('load', () => {
		loadingVideo();
		pageTop();
		// 外部ファイル
		logoRotateAnimation(
			'data-rotate_icon',
			true
		);
	});
})();
